import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSolomonIslands = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1225)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M20.4856 20.4856C24.9861 15.9851 25.1638 8.79988 21.0206 4.08618L12 11.9999L4.08618 21.0206C8.79988 25.1638 15.9851 24.9861 20.4856 20.4856Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.51441 3.5144C8.01491 -0.986106 15.2001 -1.16381 19.9138 2.97941L12 12.0001L2.97947 19.9138C-1.1638 15.2001 -0.986052 8.0149 3.51441 3.5144Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.9137 2.97937L2.97937 19.9138C3.15056 20.1085 3.32831 20.2996 3.51435 20.4856C3.70035 20.6716 3.89146 20.8493 4.08627 21.0206L21.0205 4.08618C20.8494 3.89137 20.6716 3.70031 20.4855 3.51426C20.2996 3.32835 20.1085 3.15056 19.9137 2.97937Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.05597 4.17355L5.31505 4.97075H6.15322L5.47513 5.46336L5.73411 6.26056L5.05597 5.76786L4.37783 6.26056L4.63691 5.46336L3.95877 4.97075H4.79699L5.05597 4.17355Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.33748 4.17355L9.59656 4.97075H10.4347L9.75659 5.46336L10.0156 6.26056L9.33748 5.76786L8.65934 6.26056L8.91842 5.46336L8.24028 4.97075H9.07845L9.33748 4.17355Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.05597 8.34763L5.31505 9.14483H6.15322L5.47513 9.63748L5.73411 10.4347L5.05597 9.94198L4.37783 10.4347L4.63691 9.63748L3.95877 9.14483H4.79699L5.05597 8.34763Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.33748 8.34763L9.59656 9.14483H10.4347L9.75659 9.63748L10.0156 10.4347L9.33748 9.94198L8.65934 10.4347L8.91842 9.63748L8.24028 9.14483H9.07845L9.33748 8.34763Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.19675 6.26056L7.45583 7.05776H8.29395L7.61586 7.55042L7.87489 8.34762L7.19675 7.85492L6.51861 8.34762L6.77764 7.55042L6.0995 7.05776H6.93772L7.19675 6.26056Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1225",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgSolomonIslands;
